export default "{\n    \"generic\": \"Algo salió mal.\"\n}\n"